/**
 * Promo Banner (Morning Sale) > Scroll to cart if Sales Banner does not exist
 */
 if ($('#promoBanner').length) { 
    let salesBannerHeight = Math.floor($('#salesBanner').outerHeight());
    let promoBannerHeight = Math.floor($('#promoBanner').outerHeight());

    $('#promoBanner').on('click', function (event) {
        if ($('body').hasClass('show-promoBanner')) {
            if ($('#salesBanner').length) {
                $('html, body').animate({
                    scrollTop: $("#promoBanner").offset().top - salesBannerHeight
                }, 1200);
            } else if ($('#topSectionBanner').length) {
                $('html, body').animate({
                    scrollTop: $("#topSectionBanner").offset().top - promoBannerHeight
                }, 1200);
            } else {
                $('html, body').animate({
                    scrollTop: $("#promoBanner").offset().top
                }, 1200);
            }
        } else {
            $('html, body').animate({
                scrollTop: $("#orderNow").offset().top
            }, 1200);
        }
    });
}